import styled from 'styled-components';

import $Icon from '../Icon';

import {commonPalette} from '../../styles/palette';

export const getContentStyles = isMobile => ({
  border: 1,
  borderRadius: 4,
  boxShadow: [
    '0 24px 38px rgba(0, 0, 0, 0.14)',
    '0 9px 46px rgba(0, 0, 0, 0.12)',
    '0 11px 15px rgba(0, 0, 0, 0.2)'
  ].join(),
  display: 'flex',
  flexDirection: 'column',
  transform: isMobile ? 'translate(-47%)' : 'translate(-50%)',
  overflow: 'auto',
  width: isMobile ? '79%' : '90%',
  maxWidth: '560px',
  inset: isMobile ? '20% 48% 40px' : '40% 50% 40px',
  marginBottom: 'auto',
  position: 'absolute',
  maxHeight: '185px'
});

export const getOverlayStyles = () => ({
  backgroundColor: 'rgba(0, 0, 0, 0.45)',
  zIndex: '1000'
});

export const getButtonContentStyles = () => ({
  width: '496px',
  marginLeft: '12px'
});

export const Title = styled.div`
  font-size: ${({isMobile}) => (isMobile ? '20px' : '22px')};
  line-height: 26.4px;
  color: ${commonPalette.txBlack};
  margin-bottom: ${({isMobile}) => (isMobile ? '4%' : '5px')};
  margin-left: ${({isMobile}) => (isMobile ? '0' : '12px')};
  margin-top: ${({isMobile}) => (isMobile ? '0' : '4px')};
`;

export const StyledText = styled.div`
  font-size: 14px;
  line-height: 20px;
  color: ${commonPalette.txBlack};
  margin-bottom: ${({isMobile}) => (isMobile ? '5%' : '28px')};
  margin-left: ${({isMobile}) => (isMobile ? '0' : '12px')};
`;

export const CloseButton = styled($Icon).attrs({
  name: 'close'
})`
  height: ${({isMobile}) => (isMobile ? '18px' : '22px')};
  color: ${commonPalette.txBlack};
  margin-top: 4px;
`;

export const HeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 0;
  margin: ${({isMobile}) => (isMobile ? '0' : '0 0 20px 0')};
`;
